module.exports = __webpack_public_path__ + "img/fengcai5.1a9371f0.png";